import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this,
      args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

window.debounce = debounce;


function throttle(func, duration) {

  let shouldWait = false

  return function (...args) {

    if (!shouldWait) {

      func.apply(this, args)

      shouldWait = true

      setTimeout(function () {

        shouldWait = false

      }, duration)

    }
  }
}

window.throttle = throttle;


function decodeHTMLEntities(text) {
  var entities = [
    ['amp', '&'],
    ['apos', '\''],
    ['#x27', '\''],
    ['#x2F', '/'],
    ['#39', '\''],
    ['#47', '/'],
    ['lt', '<'],
    ['gt', '>'],
    ['nbsp', ' '],
    ['quot', '"']
  ];

  for (var i = 0, max = entities.length; i < max; ++i)
    text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

  return text;
}

window.decodeHTMLEntities = decodeHTMLEntities;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
